import { parseTokenUid, Token, TokenSchema } from '../models/Token'
import { getFinder, getInserter } from 'src/util/src/zod'
import { already } from '../../util/src/date'
import { GHST } from './allTassets'
import { GMT, GST } from '../../Stepn/data/allTassets'
import { todo } from '../../util/src/todo'
import { GENE, KI } from '../../Genopets/data/allTassets'
import { LSTAR } from '../../Letmespeak/data/allTassets'

export const allTokens: Token[] = []

export const addToken = getInserter<Token>('Token', TokenSchema, parseTokenUid, allTokens)

export const findToken = getFinder(parseTokenUid, allTokens)

export const Aavegotchi_GHST = addToken({
  id: 'Aavegotchi_GHST',
  asset: GHST,
  tokenomics: ['https://wiki.aavegotchi.com/en/tokenomics'],
  tokenomicsAvailableAt: already,
})

export const Stepn_GST = addToken({
  id: 'Stepn_GST',
  asset: GST,
  tokenomics: todo([]),
  tokenomicsAvailableAt: already,
})

export const Stepn_GMT = addToken({
  id: 'Stepn_GMT',
  asset: GMT,
  tokenomics: todo([]),
  tokenomicsAvailableAt: already,
})

export const Genopets_GENE = addToken({
  id: 'Genopets_GENE',
  asset: GENE,
  tokenomics: [
    // source: https://docsend.com/view/b9bqd2j78nekzdgr
    'https://i.imgur.com/ILSDwaz.png',
    'https://i.imgur.com/FjIxi2p.png',
  ],
  tokenomicsAvailableAt: already,
})

export const Genopets_KI = addToken({
  id: 'Genopets_KI',
  asset: KI,
  tokenomics: [],
  tokenomicsAvailableAt: null,
})

export const Letmespeak_LSTAR = addToken({
  id: 'Letmespeak_LSTAR',
  asset: LSTAR,
  tokenomics: [],
  tokenomicsAvailableAt: null,
})
